'use client';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="max-w-xl space-y-3">
        <h1 className="text-2xl font-semibold text-foreground">This screen failed to load</h1>
        <p className="text-sm text-muted-foreground">
          Please retry. If the issue persists, capture correlation digest{' '}
          <span className="font-mono text-xs">{error.digest ?? 'n/a'}</span> for support.
        </p>
      </div>
      <Button type="button" onClick={() => reset()}>
        Retry
      </Button>
    </div>
  );
}
